export function formatNumber(value: number, fractionLength = 0, integerLength = 1, locale = 'en', minimumFractionDigits?: number) {
    if (minimumFractionDigits === undefined) {
        minimumFractionDigits = fractionLength;
    }
    return value.toLocaleString(locale, {
        maximumFractionDigits: fractionLength,
        minimumFractionDigits,
        minimumIntegerDigits: integerLength,
    });
}

/* eslint-disable @typescript-eslint/no-magic-numbers */
const VALUE_SHORTENINGS = new Map<number, string>([
    [1e15, 'P'],
    [1e12, 'T'],
    [1e9, 'G'],
    [1e6, 'M'],
    [1e3, 'K'],
]);

/* eslint-enable no-magic-numbers */

export function shortenNumber(value: number, fractionLength = 0, locale = 'en'): string {
    let result = [...VALUE_SHORTENINGS.entries()].find(([div]) => value / div > 1);
    if (result) {
        let [divisor, symbol] = result;
        return `${formatNumber(value / divisor, fractionLength, 1, locale)}${symbol}`;
    } else {
        return value.toString();
    }
}

export function randomInteger(min, max) {
    let rand = min + Math.random() * (max - min);
    return Math.round(rand);
}
